import React from "react";
import { graphql } from "gatsby";
import { Helmet } from "react-helmet";
import Layout from "@herb/layouts";
import SEO from "@herb/components/seo";
import { deployUrl } from "@herb/utils";
import HempBanHero from "@herb/components/HempBan/HempBanHero";
import HempBanKeyDates from "@herb/components/HempBan/HempBanKeyDates";
import HempBanLoophole from "@herb/components/HempBan/HempBanLoophole";
import HempBanStories from "@herb/components/HempBan/HempBanStories";
import HempBanAffected from "@herb/components/HempBan/HempBanAffected";
import HempBanImpacted from "@herb/components/HempBan/HempBanImpacted";
import HempBanWhatCanDo from "@herb/components/HempBan/HempBanWhatCanDo";
import HempBanProducts from "@herb/components/HempBan/HempBanProducts";
import HempBanDisclaimer from "@herb/components/HempBan/HempBanDisclaimer";
import "./index.css";
import Disclaimer from "../../components/Disclaimer";

const HempBanPage = ({ data, pageContext }) => {
  const { wordpressWpPage: page } = data;
  const { noindex } = pageContext;
  const content = page?.contentHempBan || {};

  const breadcrumbs = [
    {
      name: page.title,
      url: `/${(page || {}).slug}`
    }
  ];

  return (
    <div className="hemp-ban-page">
      <Layout page="hemp-ban">
        <>
          {noindex ? (
            <Helmet>
              <meta name="robots" content="noindex" />
            </Helmet>
          ) : (
            <></>
          )}
        </>
        <SEO
          title={page.title}
          description={content?.heroBanner?.subheading || page.title}
          url={`/${(page || {}).slug}`}
          canonical={`${deployUrl}/${(page || {}).slug}`}
          breadcrumbs={breadcrumbs}
        />
        <Disclaimer type="brands" />
        <HempBanHero heroBanner={content.heroBanner} />
        <HempBanKeyDates keyDatesSection={content.keyDatesSection} />

        <section className="hb-section">
          <div className="hb-container">
            <div className="hb-story-grid">
              <HempBanLoophole whatsHappening={content.whatsHappening} />
              <HempBanStories whatsHappening={content.whatsHappening} />
            </div>
          </div>
        </section>

        <HempBanAffected whatsAffected={content.whatsAffected} />
        <HempBanImpacted whosImpacted={content.whosImpacted} />
        <HempBanWhatCanDo whatCanDo={content.whatCanDo} />
        <HempBanProducts beforeChanges={content.beforeChanges} />
        <HempBanDisclaimer footerSection={content.footerSection} />
      </Layout>
    </div>
  );
};

export default HempBanPage;

export const pageQuery = graphql`
  query($id: String!) {
    wordpressWpPage(id: { eq: $id }) {
      id
      title
      slug
      uri
      modifiedGmt
      contentHempBan {
        heroBanner {
          heading
          subheading
          heroFooterText
          button {
            buttonLink
            buttonText
          }
          backgroundImage {
            altText
            sourceUrl
          }
          backgroundImageMobile {
            altText
            sourceUrl
          }
        }
        keyDatesSection {
          badgeText
          heading
          dates {
            heading
            subheading
            status
          }
          cards {
            badgeStyle
            badgeText
            heading
            subheading
            text
            footerText
          }
        }
        whatsHappening {
          badge1Text
          badge2Text
          heading1
          heading2
          text1
          cards {
            title
            text
            icon {
              altText
              sourceUrl
            }
          }
          articles {
            ... on WordpressWpPost {
              id
              title
              slug
              uri
              categories {
                nodes {
                  name
                  slug
                  databaseId
                  parentId
                  wpParent {
                    node {
                      id
                    }
                  }
                }
              }
              featuredImage {
                node {
                  altText
                  sourceUrl
                }
              }
            }
          }
        }
        whatsAffected {
          badgeText
          heading
          cards {
            title
            style
            rows {
              text
              icon {
                altText
                sourceUrl
              }
            }
          }
        }
        whosImpacted {
          badgeText
          heading
          cards {
            badgePosition
            badgeText
            heading
            text
            image {
              altText
              sourceUrl
            }
            imageMobile {
              altText
              sourceUrl
            }
          }
        }
        whatCanDo {
          badgeText
          topText
          number
          heading
          text
          rightHeading
          statesMapImage {
            altText
            sourceUrl
          }
          statesNames {
            state
          }
          cards {
            number
            heading
            text
            image {
              altText
              sourceUrl
            }
          }
        }
        beforeChanges {
          badgeText
          heading
          text
          cards {
            heading
            text
            cardBadge
            buttonText
            buttonLink
            image {
              altText
              sourceUrl
            }
          }
        }
        footerSection {
          lastUpdated
          disclaimer
        }
      }
    }
  }
`;
